import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MousePositionService {
  public readonly mousePosition$: Observable<{ x: number; y: number }> = fromEvent<MouseEvent>(
    window,
    'mousemove',
  ).pipe(
    map((e) => ({ x: e.clientX, y: e.clientY })),
    shareReplay(1),
  );
}
